import { Component } from '@angular/core';
import { HeroBannerComponent } from '../Components/hero-banner/hero-banner.component';
@Component({
  selector: 'app-faq-page',
  standalone: true,
  imports: [HeroBannerComponent],
  templateUrl: './faq-page.component.html',
  styleUrl: './faq-page.component.scss',
})
export class FaqPageComponent {
  steps = [
    {
      title: 'Initial Meet',
      description: 'We meet with you to understand your needs and vision.',
      image: 'assets/images/step1.jpg',
    },
    {
      title: 'Concept Development',
      description: 'Our team develops a concept based on your requirements.',
      image: 'assets/images/step2.jpg',
    },
    {
      title: 'Design Approval',
      description: 'We present the design for your approval.',
      image: 'assets/images/step3.jpg',
    },
    {
      title: 'Material Selection',
      description: 'You choose the materials for your project.',
      image: 'assets/images/step4.jpg',
    },
    {
      title: 'Detailed Planning',
      description: 'We create detailed plans and timelines for the project.',
      image: 'assets/images/step5.jpg',
    },
    {
      title: 'Production',
      description: 'Your project goes into production.',
      image: 'assets/images/step6.jpg',
    },
    {
      title: 'Quality Check',
      description: 'We perform quality checks to ensure everything is perfect.',
      image: 'assets/images/step7.jpg',
    },
    {
      title: 'Installation Preparation',
      description: 'We prepare for the installation process.',
      image: 'assets/images/step8.jpg',
    },
    {
      title: 'Installation',
      description: 'Our team installs the product at your location.',
      image: 'assets/images/step9.jpg',
    },
    {
      title: 'Final Review',
      description:
        'We review the final product with you to ensure satisfaction.',
      image: 'assets/images/step10.jpg',
    },
  ];
}
